'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(currentValue) {
  return !currentValue ? '' : ('' + currentValue).toUpperCase().slice(0, 9);
};

var validate = function validate(value) {
  return /^CA\d{6}$/.test(value) || /^CAF\d{6}$/.test(value);
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});